import React from "react";

export default function PrivacyInfoBox({ policyUrl, contactEmail }) {
    return (
        <div className="pof-info-box">
            <p>
                At Sports Innovation Lab, we offer consumers nationwide a way to exercise
                various rights with respect to their personal information, including the
                right to:
            </p>
            <ul>
                <li>Access the personal information we have about you</li>
                <li>Delete the personal information we may have about you</li>
                <li>
                    Opt out of the sale or sharing of your personal information for
                    advertising purposes
                </li>
            </ul>
            <p>
                In the form below, we only require your first name, last name and email
                in order to delete your information.
            </p>
            <p>
                Once we receive your request, we may verify your identity and respond, as
                required by law.
            </p>
            <p>
                For more details about your rights or our privacy practices, please
                review our{" "}
                <a href={policyUrl} target="_blank" rel="noreferrer">
                    Privacy Policy
                </a>{" "}
                or contact us at{" "}
                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            </p>
        </div>
    );
}
